import React from "react";
import { ExpensesSearch } from "../ExpensesSearch";

export const MyExpensesSearch: React.FC = () => (
  <ExpensesSearch type="MyExpenses" />
);
